/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('SaleProduct_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceSaleS = $resource(baseUrl + 'rest/saleProducts/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
        return resourceSaleS;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('SaleProduct',["SaleProduct_Resource","ProductCategoryData","ProductData","SaleProductData","HumanResourceData","TaxMode","SaleItem","ProductCategory","Product","TypeOfSale","ProductStatCategorie","ZeroPercentTvaDateCorrection",
        function (SaleProduct_Resource,ProductCategoryData,ProductData,SaleProductData,HumanResourceData,TaxMode,SaleItem,ProductCategory,Product,TypeOfSale,ProductStatCategorie,ZeroPercentTvaDateCorrection)
    {
    //SaleProduct inherit from Activity
    var  SaleProduct = function (saleProductRes,isPreviousVersion)
    {
        SaleItem.call(this);

        this.id = null;
        this.label = null;
        this.price = 0;
        this.vat = null;
        this.vatCode = null;
        this.quantity = 0;
        this.originalPrice = 0;
        this.discountPercent = 0;
        this.product=null;
        this.sale = null;
        this.humanResource;
        this.version = null;
        this.loadObject(saleProductRes)
        this.loadRef();
        if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
            SaleProductData.add(this);
    }

    SaleProduct.prototype = Object.create(SaleItem.prototype);//inherit functions from SaleItem

    SaleProduct.prototype.loadObject = function(object)
    {

        if (object!==undefined && object!=null)
        {
            if (!this.id)
                this.id=object.id;
            this.label=object.label;
            this.price=object.price;
            this.vat=object.vat;
            this.vatCode=object.vatCode;
            if (object.originalPrice!==undefined && object.originalPrice)
                this.originalPrice=object.originalPrice;
            else
                this.originalPrice=object.price;
            this.discountPercent=object.discountPercent;
            this.quantity=object.quantity;
            this.productId=object.productId;
            if (object.humanResourceId)
                this.humanResource = HumanResourceData.getById(object.humanResourceId);
            if (object.version)
                this.version = object.version;
        }
    };
    SaleProduct.prototype.loadRef = function()
    {
        if (this.productId)
            this.product = ProductData.getById(this.productId);

    };
    SaleProduct.prototype.copyDataTo = function(object)
    {

        object.id=this.id;
        object.label=this.label;
        object.price=this.price;
        object.vat=this.vat;
        object.vatCode=this.vatCode;
        object.originalPrice=this.originalPrice;
        object.discountPercent=this.discountPercent;
        object.quantity=this.quantity;
        if (this.humanResource)
            object.humanResourceId = this.humanResource.id;

        if (this.product)
            object.productId = this.product.id;
        else
            object.productId = null;

        if (this.sale)
            object.saleId = this.sale.id;
        else
            object.saleId = null;
    };
    SaleProduct.prototype.getObjectResource = function()
    {
        var saleProductRes = new SaleProduct_Resource();
        this.copyDataTo(saleProductRes);
        return saleProductRes;
    };
    SaleProduct.prototype.setIdUsingObject = function(object)
    {
        this.id = object.id;
    };
    SaleProduct.prototype.setId = function(id)
    {
        this.id = id;
    };
    SaleProduct.prototype.getId = function()
    {
        return this.id;
    };
    SaleProduct.prototype.getLabel = function()
    {
        return this.label;
    };
    SaleProduct.prototype.getPrice = function()
    {
        return this.price;
    };
    SaleProduct.prototype.getProduct = function()
    {
        return this.product;
    };
    SaleProduct.prototype.getItem = function()
    {
        return this.product;
    };
    SaleProduct.prototype.getItemCategoryType = function()
    {
        return ProductCategory;
    };
    SaleProduct.prototype.getItemType = function()
    {
        return Product;
    };
    SaleProduct.prototype.getDiscountPrice = function(taxMode)
    {
        let price = 0;
        if (this.sale.isStatusSoldOrCreditOrCanceled()) {
            price = this.price;
            //apply global discount on price
            if (this.sale.discountPercent !== 0) {
                price -= this.sale.discountPercent * price / 100;
            }

            if(taxMode === TaxMode.HT){
                let vat,
                    day = this.sale.day.getDate();
                //TODO the constant ZeroPercentTvaDateCorrection is deprecated, This is a temporary solution to not impact the history
                if (this.vat == null && !ZeroPercentTvaDateCorrection.isBeforeCorrection(day) ||
                    !this.vat && ZeroPercentTvaDateCorrection.isBeforeCorrection(day)){
                    vat = this.sale.vat;
                }
                else{
                    vat = this.vat;
                }
                price = price / (100 + vat) * 100;
            }
        }
        return price;
    };

    /**
     * @override SaleItem.prototype.matchSpecificMatchingOfItem
     */
    SaleProduct.prototype.matchSpecificMatchingOfItem = function(saleObject){
        let matchSpecificMatchingOfItem = false;
        if((saleObject === ProductStatCategorie) ||
            (saleObject === ProductStatCategorie.ALL ||
                (saleObject === TypeOfSale.ALL_WITH_PRODUCT_OR_NOT && (this.getSale().saleServices.length > 0)) ||
                (saleObject === TypeOfSale.SERVICE_AND_PRODUCT && this.getSale().saleServices.length > 0))) {
            matchSpecificMatchingOfItem = true;
        }
        return matchSpecificMatchingOfItem;
    };

    /**
     * @override SaleItem.prototype.getQuantity
     */
    SaleProduct.prototype.getQuantity = function(){
        return this.quantity;
    };

    return SaleProduct;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SaleProductSrv',["$log","ServerSrv","DayData","SaleProductData","SaleProduct","ActivitySrv","SaleData",
        function ($log,ServerSrv,DayData,SaleProductData,SaleProduct,ActivitySrv,SaleData)
    {
        var  bpSrv = {};

        bpSrv.save =  function(saleProduct,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bpSrv.saveSync, saleProduct, successFunction, errorFunction);
        };
        bpSrv.saveSync =  function(saleProduct,successFunction,errorFunction)
        {
            var bsRes = saleProduct.getObjectResource();
            bsRes.$save({}, //no params
                function (data) {
                    try {
                        // now we can set the id
                        saleProduct.setId(data.id);
                        if (!saleProduct.version || (data.version && data.version > saleProduct.version))
                            saleProduct.version = data.version;
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        bpSrv.updateLocally =  function(id,resource)
        {
            var saleProduct =  SaleProductData.getById(id);

            if (saleProduct && saleProduct.version && resource.version && resource.version < saleProduct.version)
                return null;

            if (saleProduct!=null)
            {
                saleProduct.loadObject(resource);
                saleProduct.id = id;
                //remove from sale
                if(saleProduct.sale)
                    saleProduct.sale.removeSaleProduct(saleProduct);
                if(resource.saleId)
                {
                    var sale = SaleData.getById(resource.saleId);
                    if (sale)
                        sale.addSaleProduct(saleProduct);
                }
            }

            return saleProduct;
        };
        bpSrv.removeLocally =  function(id,resource)
        {
            var saleProduct =  SaleProductData.getById(id);
            if (saleProduct && saleProduct.version && resource.version && resource.version < saleProduct.version)
                return null;
            if (saleProduct!=null)
            {
                //remove from sale
                if(saleProduct.sale)
                    saleProduct.sale.removeSaleProduct(saleProduct);
            }
            return saleProduct;
        };
        bpSrv.addLocally =  function(id,resource)
        {
            var saleProduct =  SaleProductData.getById(id) ;
            if (saleProduct && saleProduct.version && resource.version && resource.version < saleProduct.version)
                return null;

            if (saleProduct!=null) //check if resource already exist inside index (current action could be a 'cancel')
                saleProduct.loadObject(resource);
            else
            {
                saleProduct = new SaleProduct(resource);
            }
            saleProduct.id = id;
            //add to sale
            if(resource.saleId)
            {
                var sale = SaleData.getById(resource.saleId);
                if (sale)
                    sale.addSaleProduct(saleProduct);
            }

            return saleProduct;
        };
        bpSrv.getPreviousVersionInstance =  function(resource)
        {
            var saleProduct =  new SaleProduct(resource,true);
            if(resource.saleId)
                saleProduct.sale = SaleData.getById(resource.saleId);
            return saleProduct;

        };

        return bpSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('SaleProductData',["$log", function ($log)
    {
        var  saleProductData =
        {
            indexSaleProducts : []
        };
        saleProductData.getById =  function(saleProductId)
        {
            for (var i=0;i<this.indexSaleProducts.length;i++)
                if (this.indexSaleProducts[i].id==saleProductId)
                    return this.indexSaleProducts[i];
            return null;
        }
        saleProductData.getIndexOf =  function(saleProduct)
        {
            if (saleProduct)
                return this.indexSaleProducts.indexOf(saleProduct);
            return -1;
        }
        saleProductData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexSaleProducts.length)
                return this.indexSaleProducts[index];
            else
                return null;
        }
        saleProductData.add =  function(saleProduct)
        {
            this.indexSaleProducts.push(saleProduct);
            return this.indexSaleProducts.length-1;
        }
        saleProductData.clear =  function()
        {
            saleProductData.indexSaleProducts = [];
        }


        return saleProductData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/SaleProduct.js